/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Edit_In_Studio_FailedInputs */

const en_toast_edit_in_studio_failed = /** @type {(inputs: Toast_Edit_In_Studio_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't open this session in the Studio`)
};

const de_toast_edit_in_studio_failed = /** @type {(inputs: Toast_Edit_In_Studio_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Session konnte nicht im Studio geöffnet werden`)
};

/**
* | output |
* | --- |
* | "Couldn't open this session in the Studio" |
*
* @param {Toast_Edit_In_Studio_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_edit_in_studio_failed = /** @type {((inputs?: Toast_Edit_In_Studio_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Edit_In_Studio_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_edit_in_studio_failed(inputs)
	return de_toast_edit_in_studio_failed(inputs)
});